<template>
	<v-card class="chart-card" elevation="2" rounded="xl">

		<div class="chart-header">
			<div class="chart-header-left">
				<div class="chart-icon-box">
					<v-icon size="18" color="white">mdi-chart-donut</v-icon>
				</div>
				<div>
					<p class="chart-title">Abonnements</p>
					<p class="chart-subtitle">{{ subtitleLabel }}</p>
				</div>
			</div>

			<div v-if="salleFilters.length > 1" class="chart-filters">
				<button
					v-for="f in salleFilters"
					:key="f._id || 'all'"
					class="filter-btn"
					:class="{ 'filter-btn--active': selectedSalleId === f._id }"
					@click="selectedSalleId = f._id"
				>
					{{ f.name }}
				</button>
			</div>
		</div>

		<v-divider></v-divider>

		<v-card-text class="chart-body">
			<pie-chart
				:data="chartUrl"
				:key="chartUrl"
				:messages="{ empty: 'Aucune donnée disponible' }"
				:colors="['#c62828', '#1565c0', '#1a1a2e', '#00695c', '#e65100']"
				:donut="true"
				height="260px"
			></pie-chart>
		</v-card-text>

	</v-card>
</template>

<script>
import server from "@/config/address";
export default {
	name: "SubscriptionClients",
	data() {
		return {
			server,
			selectedSalleId: null,
		};
	},
	computed: {
		venues() {
			return this.$store.getters.venues || [];
		},
		salleFilters() {
			return [{ _id: null, name: "Toutes" }, ...this.venues];
		},
		chartUrl() {
			const base = `${this.server.url}/subscription/chart/customer`;
			return this.selectedSalleId ? `${base}?salle=${this.selectedSalleId}` : base;
		},
		subtitleLabel() {
			if (!this.selectedSalleId) return "Répartition par type — toutes salles";
			const s = this.venues.find(v => v._id === this.selectedSalleId);
			return s ? `Répartition par type — ${s.name}` : "Répartition par type";
		},
	},
};
</script>

<style scoped>
.chart-card {
	font-family: Montserrat, sans-serif;
	height: 100%;
}

.chart-header {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 18px 20px 14px;
	gap: 12px;
	flex-wrap: wrap;
}

.chart-header-left {
	display: flex;
	align-items: center;
	gap: 14px;
}

.chart-icon-box {
	width: 38px;
	height: 38px;
	border-radius: 10px;
	background: #1565c0;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
}

.chart-title {
	font-size: 0.92rem;
	font-weight: 700;
	color: #111827;
	margin: 0 0 2px;
}

.chart-subtitle {
	font-size: 0.72rem;
	color: #9ca3af;
	margin: 0;
}

.chart-filters {
	display: flex;
	gap: 4px;
	background: #f3f4f6;
	border-radius: 10px;
	padding: 4px;
	flex-wrap: wrap;
}

.filter-btn {
	padding: 5px 12px;
	border-radius: 7px;
	border: none;
	background: transparent;
	font-family: Montserrat, sans-serif;
	font-size: 0.72rem;
	font-weight: 600;
	color: #6b7280;
	cursor: pointer;
	transition: background 0.15s, color 0.15s;
	white-space: nowrap;
}

.filter-btn:hover {
	background: #e5e7eb;
	color: #374151;
}

.filter-btn--active {
	background: #ffffff;
	color: #1565c0;
	box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
}

.chart-body {
	padding: 16px 20px 12px;
}
</style>
